import { render, staticRenderFns } from "./UiScrollbarBox.vue?vue&type=template&id=fbf27eec&"
import script from "./UiScrollbarBox.vue?vue&type=script&lang=js&"
export * from "./UiScrollbarBox.vue?vue&type=script&lang=js&"
import style0 from "./UiScrollbarBox.vue?vue&type=style&index=0&id=fbf27eec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports